// 商品詳細ページ　商品画像
var galleryTop3 = new Swiper(".product_main_images", {
  loop: true,
  effect: "fade",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: {
      el: ".product_main_thumbnail",
      slidesPerView: 7, // サムネイル画像の枚数
      spaceBetween: 7,
    },
  },
});

// 商品詳細ページ　商品説明
$(function () {
  $(".box_product_description .switch").on("click", function () {
    $(this).prev(".text").slideToggle();
    $(this).children("i").toggle();
  })
})
$(function () {
  $(".box_product_description h2").on("click", function () {
    $(this).next(".text").slideToggle();
    $(this).next(".text").next(".switch").children("i").toggle();
  })
})

// 商品詳細ページ
$(function () {
  // メッセージカード
  $("#SingleOptionSelector-1").change(function () {
    var r = $(this).val();
    if (r == '不要') {
      $(".option_card_name").slideUp();
      $(".option_card_message").slideUp();
    } else {
      $(".option_card_name").slideDown();
      $(".option_card_message").slideDown();
    }
  })
  // 熨斗
  $("#SingleOptionSelector-0").change(function () {
    var r = $(this).val();
    console.log("熨斗チェック：" + r.indexOf('熨斗'));
    if (r.indexOf('熨斗') < 0) {
      $(".option_noshi").slideUp();
      $(".option_noshi select").attr("selected", false);
      $(".option_noshi select").val("不要");
      $(".option_noshi_name").slideUp().css("opacity", 0);
      $(".option_noshi_name").find("input").val("");
    } else {
      $(".option_noshi").slideDown().css("display", "flex");
    }
  })
})

/**/
$(function () {
  $('label[for="SingleOptionSelector-0"]').each(function () {
    var item_name = $(this).text();
    var item_name_before = item_name.slice(0, item_name.indexOf("・") + 1);
    var item_name_after = item_name.slice(item_name.indexOf("・") + 1);
    var item_list_name = item_name_before + "<br>" + item_name_after;
    $(this).html(item_list_name);
  });
});


$(function() {
  $('.tab').on('click', function() {
    $('.tab, .panel').removeClass('active');
  
    $(this).addClass('active');
     
    var index = $('.tab').index(this);
    $('.panel').eq(index).addClass('active');
  });
});

// PC sticky
var scroll;
var objH = $('#product_right_table').outerHeight();
var objTop = $('#product_right_table').offset().top;
var objBottom = objTop + objH;
$(window).on('scroll', function(){
  scroll = $(window).scrollTop();
  if(scroll >= objBottom){
    //ここに処理
    $('.product-single__meta').addClass('sticky');
  }else{
    $('.product-single__meta').removeClass('sticky');
  }
});
var scroll2;
var objH2 = $('.product-single__meta').outerHeight();
var objTop2 = $('.product-single__meta').offset().top;
var objBottom2 = objTop2 + objH2;
$(window).on('scroll', function(){
  scroll2 = $(window).scrollTop();
  if(scroll2 >= objBottom2){
    //ここに処理
    $('.product-single__meta').addClass('hidden');
  }else{
    $('.product-single__meta').removeClass('hidden');
  }
});

// 要素の移動を行う関数
function moveElement() {
  if (window.innerWidth <= 767) {
    // 移動対象の要素と参照要素を取得
    const elementToMove = document.getElementById('product_cta');
    const referenceElement = document.getElementById('priduct_reference');

    // 参照要素の後に移動対象の要素を挿入
    if (elementToMove && referenceElement) {
        const parent = referenceElement.parentNode;
        parent.insertBefore(elementToMove, referenceElement.nextSibling);
    }
    }
}

// ページ読み込み時とウィンドウサイズ変更時に関数を呼び出す
window.addEventListener('load', moveElement);